import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function MainMenu(props) {
    const [path, setPath] = useState("");

    useEffect(() => {
        setPath(window.location.href);
    }, [])

    // function showAllDemos(e) {
    //     let demoItems = document.querySelectorAll('.demo-item.hidden');

    //     for (let i = 0; i < demoItems.length; i++) {
    //         demoItems[i].classList.toggle('show');
    //     }

    //     document.querySelector('.view-all-demos').classList.toggle('disabled-hidden');
    //     e.preventDefault();
    // }

    return (
        <nav className="main-nav">
            <ul className="menu sf-arrows">
                <li className={`megamenu-container`} id="menu-home">
                    <Link to={`/`} className="sf-with-li">Home</Link>

                </li>


                <li className={path.indexOf("pages") > -1 ? 'active' : ''}>
                    <Link to={`/shop`} className="sf-with-li ">SHOP</Link>

                </li>

                <li className={`megamenu-container`} >
                    <Link to={`/about`} className="sf-with-li">About</Link>

                </li>
                <li className={`megamenu-container`} >
                    <Link to={`/faq`} className="sf-with-li">FAQ</Link>

                </li>
                <li className={`megamenu-container`} >
                    <Link to={`/contact`} className="sf-with-li">Contact Us</Link>

                </li>
            </ul>
        </nav>
    );
}